import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { SelfProposalPage } from 'app/BCKSPage/SelfProposal/SelfProposalPage'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PageProps {
  isKSSelectionEnabled: boolean
  isKSSeleksiTertutupEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')
  const isKSSeleksiTertutupEnabled = await isToggleEnabled(
    'ks-selection-seleksi-tertutup-enabled'
  )

  return {
    props: {
      isKSSelectionEnabled,
      isKSSeleksiTertutupEnabled,
    },
  }
}

const Page = (props: PageProps) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return (
    <SelfProposalPage
      isKSSeleksiTertutupEnabled={props.isKSSeleksiTertutupEnabled}
    />
  )
}

export default Page
